import styles from "./TrustStrip.module.css";

const ITEMS = [
  "✈ Air Ticketing",
  "🌍 Tour Packages",
  "📋 Visa Assistance",
  "💼 Corporate Travel",
  "🌐 Overseas Careers",
];

export default function TrustStrip() {
  return (
    <div className={styles.strip}>
      {ITEMS.map((item) => (
        <span key={item} className={styles.item}>
          <span className={styles.dot} />
          {item}
        </span>
      ))}
    </div>
  );
}
